import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { fromEvent } from 'rxjs';
import { defineCustomElements } from '@cxs-designsystem/core/dist/loader';

/* eslint-disable */
/* tslint:disable */
var proxyInputs = function (Cmp, inputs) {
    var Prototype = Cmp.prototype;
    inputs.forEach(function (item) {
        Object.defineProperty(Prototype, item, {
            get: function () {
                return this.el[item];
            },
            set: function (val) {
                var _this = this;
                this.z.runOutsideAngular(function () { return (_this.el[item] = val); });
            },
            /**
             * In the event that proxyInputs is called
             * multiple times re-defining these inputs
             * will cause an error to be thrown. As a result
             * we set configurable: true to indicate these
             * properties can be changed.
             */
            configurable: true,
        });
    });
};
var proxyMethods = function (Cmp, methods) {
    var Prototype = Cmp.prototype;
    methods.forEach(function (methodName) {
        Prototype[methodName] = function () {
            var _this = this;
            var args = arguments;
            return this.z.runOutsideAngular(function () { return _this.el[methodName].apply(_this.el, args); });
        };
    });
};
var proxyOutputs = function (instance, el, events) {
    events.forEach(function (eventName) { return (instance[eventName] = fromEvent(el, eventName)); });
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
    var decorator = function (cls) {
        var defineCustomElementFn = opts.defineCustomElementFn, inputs = opts.inputs, methods = opts.methods;
        if (defineCustomElementFn !== undefined) {
            defineCustomElementFn();
        }
        if (inputs) {
            proxyInputs(cls, inputs);
        }
        if (methods) {
            proxyMethods(cls, methods);
        }
        return cls;
    };
    return decorator;
}

var _c0 = ["*"];
var DsActionMenu = /** @class */ (function () {
    function DsActionMenu(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['openerClick', 'clickOutside']);
    }
    DsActionMenu.ɵfac = function DsActionMenu_Factory(t) { return new (t || DsActionMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsActionMenu.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsActionMenu, selectors: [["ds-action-menu"]], inputs: { dropdownTestId: "dropdownTestId", mobile: "mobile", open: "open", openerLabel: "openerLabel", openerTestId: "openerTestId" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsActionMenu_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsActionMenu = __decorate([
        ProxyCmp({
            inputs: ['dropdownTestId', 'mobile', 'open', 'openerLabel', 'openerTestId']
        })
    ], DsActionMenu);
    return DsActionMenu;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsActionMenu, [{
        type: Component,
        args: [{
                selector: 'ds-action-menu',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownTestId', 'mobile', 'open', 'openerLabel', 'openerTestId'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsActionMenu, { className: "DsActionMenu", filePath: "directives/proxies.ts", lineNumber: 20 }); })();
var DsBadge = /** @class */ (function () {
    function DsBadge(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsBadge.ɵfac = function DsBadge_Factory(t) { return new (t || DsBadge)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsBadge.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsBadge, selectors: [["ds-badge"]], inputs: { content: "content", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsBadge_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsBadge = __decorate([
        ProxyCmp({
            inputs: ['content', 'type']
        })
    ], DsBadge);
    return DsBadge;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsBadge, [{
        type: Component,
        args: [{
                selector: 'ds-badge',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['content', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsBadge, { className: "DsBadge", filePath: "directives/proxies.ts", lineNumber: 48 }); })();
var DsBreadcrumbElement = /** @class */ (function () {
    function DsBreadcrumbElement(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsBreadcrumbElement.ɵfac = function DsBreadcrumbElement_Factory(t) { return new (t || DsBreadcrumbElement)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsBreadcrumbElement.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsBreadcrumbElement, selectors: [["ds-breadcrumb-element"]], inputs: { breadcrumbItems: "breadcrumbItems", breadcrumbMaxWidth: "breadcrumbMaxWidth", minCount: "minCount" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsBreadcrumbElement_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsBreadcrumbElement = __decorate([
        ProxyCmp({
            inputs: ['breadcrumbItems', 'breadcrumbMaxWidth', 'minCount']
        })
    ], DsBreadcrumbElement);
    return DsBreadcrumbElement;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsBreadcrumbElement, [{
        type: Component,
        args: [{
                selector: 'ds-breadcrumb-element',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['breadcrumbItems', 'breadcrumbMaxWidth', 'minCount'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsBreadcrumbElement, { className: "DsBreadcrumbElement", filePath: "directives/proxies.ts", lineNumber: 70 }); })();
var DsBtnContainer = /** @class */ (function () {
    function DsBtnContainer(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsBtnContainer.ɵfac = function DsBtnContainer_Factory(t) { return new (t || DsBtnContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsBtnContainer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsBtnContainer, selectors: [["ds-btn-container"]], inputs: { btnItems: "btnItems", isSticky: "isSticky" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsBtnContainer_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsBtnContainer = __decorate([
        ProxyCmp({
            inputs: ['btnItems', 'isSticky']
        })
    ], DsBtnContainer);
    return DsBtnContainer;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsBtnContainer, [{
        type: Component,
        args: [{
                selector: 'ds-btn-container',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['btnItems', 'isSticky'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsBtnContainer, { className: "DsBtnContainer", filePath: "directives/proxies.ts", lineNumber: 92 }); })();
var DsButton = /** @class */ (function () {
    function DsButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsButton.ɵfac = function DsButton_Factory(t) { return new (t || DsButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsButton, selectors: [["ds-button"]], inputs: { color: "color", disabled: "disabled", href: "href", isLink: "isLink", label: "label", target: "target", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsButton = __decorate([
        ProxyCmp({
            inputs: ['color', 'disabled', 'href', 'isLink', 'label', 'target', 'type']
        })
    ], DsButton);
    return DsButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsButton, [{
        type: Component,
        args: [{
                selector: 'ds-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['color', 'disabled', 'href', 'isLink', 'label', 'target', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsButton, { className: "DsButton", filePath: "directives/proxies.ts", lineNumber: 114 }); })();
var DsButtonComponent = /** @class */ (function () {
    function DsButtonComponent(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsButtonComponent.ɵfac = function DsButtonComponent_Factory(t) { return new (t || DsButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsButtonComponent, selectors: [["ds-button-component"]], inputs: { btnConfig: "btnConfig", handleMultiLine: "handleMultiLine", inDropdown: "inDropdown", isFirstChild: "isFirstChild" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsButtonComponent = __decorate([
        ProxyCmp({
            inputs: ['btnConfig', 'handleMultiLine', 'inDropdown', 'isFirstChild']
        })
    ], DsButtonComponent);
    return DsButtonComponent;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ds-button-component',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['btnConfig', 'handleMultiLine', 'inDropdown', 'isFirstChild'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsButtonComponent, { className: "DsButtonComponent", filePath: "directives/proxies.ts", lineNumber: 136 }); })();
var DsContextualNavigation = /** @class */ (function () {
    function DsContextualNavigation(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['countrySelected', 'login', 'logout']);
    }
    DsContextualNavigation.ɵfac = function DsContextualNavigation_Factory(t) { return new (t || DsContextualNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsContextualNavigation.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsContextualNavigation, selectors: [["ds-contextual-navigation"]], inputs: { avatarSourceUrl: "avatarSourceUrl", contactUsConfig: "contactUsConfig", countrySelectorConfig: "countrySelectorConfig", disableProfileMenu: "disableProfileMenu", exploreSapLink: "exploreSapLink", hideExploreSapLink: "hideExploreSapLink", homeLogoUrl: "homeLogoUrl", landingZone: "landingZone", lastVisitedCountry: "lastVisitedCountry", loggedInUser: "loggedInUser", mainLinks: "mainLinks", mobileNavigationContext: "mobileNavigationContext", mode: "mode", notificationBellConfig: "notificationBellConfig", notifications: "notifications", profile: "profile", searchConfig: "searchConfig", shoppingCartConfig: "shoppingCartConfig", showSearchInputByDefault: "showSearchInputByDefault", translations: "translations", version: "version" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsContextualNavigation_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsContextualNavigation = __decorate([
        ProxyCmp({
            inputs: ['avatarSourceUrl', 'contactUsConfig', 'countrySelectorConfig', 'disableProfileMenu', 'exploreSapLink', 'hideExploreSapLink', 'homeLogoUrl', 'landingZone', 'lastVisitedCountry', 'loggedInUser', 'mainLinks', 'mobileNavigationContext', 'mode', 'notificationBellConfig', 'notifications', 'profile', 'searchConfig', 'shoppingCartConfig', 'showSearchInputByDefault', 'translations', 'version'],
            methods: ['changeState']
        })
    ], DsContextualNavigation);
    return DsContextualNavigation;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsContextualNavigation, [{
        type: Component,
        args: [{
                selector: 'ds-contextual-navigation',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['avatarSourceUrl', 'contactUsConfig', 'countrySelectorConfig', 'disableProfileMenu', 'exploreSapLink', 'hideExploreSapLink', 'homeLogoUrl', 'landingZone', 'lastVisitedCountry', 'loggedInUser', 'mainLinks', 'mobileNavigationContext', 'mode', 'notificationBellConfig', 'notifications', 'profile', 'searchConfig', 'shoppingCartConfig', 'showSearchInputByDefault', 'translations', 'version'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsContextualNavigation, { className: "DsContextualNavigation", filePath: "directives/proxies.ts", lineNumber: 159 }); })();
var DsContextualNavigationCountrySelector = /** @class */ (function () {
    function DsContextualNavigationCountrySelector(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['countrySelected']);
    }
    DsContextualNavigationCountrySelector.ɵfac = function DsContextualNavigationCountrySelector_Factory(t) { return new (t || DsContextualNavigationCountrySelector)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsContextualNavigationCountrySelector.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsContextualNavigationCountrySelector, selectors: [["ds-contextual-navigation-country-selector"]], inputs: { defaultActiveCountry: "defaultActiveCountry", lastVisitedCountry: "lastVisitedCountry", mobile: "mobile", open: "open", regions: "regions", searchDisabled: "searchDisabled" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsContextualNavigationCountrySelector_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsContextualNavigationCountrySelector = __decorate([
        ProxyCmp({
            inputs: ['defaultActiveCountry', 'lastVisitedCountry', 'mobile', 'open', 'regions', 'searchDisabled']
        })
    ], DsContextualNavigationCountrySelector);
    return DsContextualNavigationCountrySelector;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsContextualNavigationCountrySelector, [{
        type: Component,
        args: [{
                selector: 'ds-contextual-navigation-country-selector',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['defaultActiveCountry', 'lastVisitedCountry', 'mobile', 'open', 'regions', 'searchDisabled'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsContextualNavigationCountrySelector, { className: "DsContextualNavigationCountrySelector", filePath: "directives/proxies.ts", lineNumber: 189 }); })();
var DsContextualNavigationMobileMasthead = /** @class */ (function () {
    function DsContextualNavigationMobileMasthead(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['mobileHeaderClosed', 'loginButtonClick', 'logoutButtonClick', 'countrySelected']);
    }
    DsContextualNavigationMobileMasthead.ɵfac = function DsContextualNavigationMobileMasthead_Factory(t) { return new (t || DsContextualNavigationMobileMasthead)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsContextualNavigationMobileMasthead.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsContextualNavigationMobileMasthead, selectors: [["ds-contextual-navigation-mobile-masthead"]], inputs: { avatarSourceUrl: "avatarSourceUrl", contactUsConfig: "contactUsConfig", countrySelectorConfig: "countrySelectorConfig", disableProfileMenu: "disableProfileMenu", exploreSapLink: "exploreSapLink", hideExploreSapLink: "hideExploreSapLink", isNavItemsEmpty: "isNavItemsEmpty", lastVisitedCountry: "lastVisitedCountry", loggedInUser: "loggedInUser", mobileHeaderShown: "mobileHeaderShown", navigationContext: "navigationContext", notificationBellConfig: "notificationBellConfig", notifications: "notifications", profile: "profile", shoppingCartConfig: "shoppingCartConfig" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsContextualNavigationMobileMasthead_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsContextualNavigationMobileMasthead = __decorate([
        ProxyCmp({
            inputs: ['avatarSourceUrl', 'contactUsConfig', 'countrySelectorConfig', 'disableProfileMenu', 'exploreSapLink', 'hideExploreSapLink', 'isNavItemsEmpty', 'lastVisitedCountry', 'loggedInUser', 'mobileHeaderShown', 'navigationContext', 'notificationBellConfig', 'notifications', 'profile', 'shoppingCartConfig']
        })
    ], DsContextualNavigationMobileMasthead);
    return DsContextualNavigationMobileMasthead;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsContextualNavigationMobileMasthead, [{
        type: Component,
        args: [{
                selector: 'ds-contextual-navigation-mobile-masthead',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['avatarSourceUrl', 'contactUsConfig', 'countrySelectorConfig', 'disableProfileMenu', 'exploreSapLink', 'hideExploreSapLink', 'isNavItemsEmpty', 'lastVisitedCountry', 'loggedInUser', 'mobileHeaderShown', 'navigationContext', 'notificationBellConfig', 'notifications', 'profile', 'shoppingCartConfig'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsContextualNavigationMobileMasthead, { className: "DsContextualNavigationMobileMasthead", filePath: "directives/proxies.ts", lineNumber: 215 }); })();
var DsContextualNavigationMobileProfile = /** @class */ (function () {
    function DsContextualNavigationMobileProfile(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['loginButtonClick', 'logoutButtonClick', 'mobileMenuClicked']);
    }
    DsContextualNavigationMobileProfile.ɵfac = function DsContextualNavigationMobileProfile_Factory(t) { return new (t || DsContextualNavigationMobileProfile)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsContextualNavigationMobileProfile.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsContextualNavigationMobileProfile, selectors: [["ds-contextual-navigation-mobile-profile"]], inputs: { avatarSourceUrl: "avatarSourceUrl", loggedInUser: "loggedInUser", notifications: "notifications", open: "open", profile: "profile" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsContextualNavigationMobileProfile_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsContextualNavigationMobileProfile = __decorate([
        ProxyCmp({
            inputs: ['avatarSourceUrl', 'loggedInUser', 'notifications', 'open', 'profile']
        })
    ], DsContextualNavigationMobileProfile);
    return DsContextualNavigationMobileProfile;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsContextualNavigationMobileProfile, [{
        type: Component,
        args: [{
                selector: 'ds-contextual-navigation-mobile-profile',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['avatarSourceUrl', 'loggedInUser', 'notifications', 'open', 'profile'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsContextualNavigationMobileProfile, { className: "DsContextualNavigationMobileProfile", filePath: "directives/proxies.ts", lineNumber: 247 }); })();
var DsContextualNavigationProfile = /** @class */ (function () {
    function DsContextualNavigationProfile(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['loginButtonClick', 'logoutButtonClick']);
    }
    DsContextualNavigationProfile.ɵfac = function DsContextualNavigationProfile_Factory(t) { return new (t || DsContextualNavigationProfile)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsContextualNavigationProfile.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsContextualNavigationProfile, selectors: [["ds-contextual-navigation-profile"]], inputs: { avatarSourceUrl: "avatarSourceUrl", loggedInUser: "loggedInUser", mobile: "mobile", notifications: "notifications", profile: "profile" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsContextualNavigationProfile_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsContextualNavigationProfile = __decorate([
        ProxyCmp({
            inputs: ['avatarSourceUrl', 'loggedInUser', 'mobile', 'notifications', 'profile']
        })
    ], DsContextualNavigationProfile);
    return DsContextualNavigationProfile;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsContextualNavigationProfile, [{
        type: Component,
        args: [{
                selector: 'ds-contextual-navigation-profile',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['avatarSourceUrl', 'loggedInUser', 'mobile', 'notifications', 'profile'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsContextualNavigationProfile, { className: "DsContextualNavigationProfile", filePath: "directives/proxies.ts", lineNumber: 277 }); })();
var DsContextualNavigationSubmenu = /** @class */ (function () {
    function DsContextualNavigationSubmenu(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsContextualNavigationSubmenu.ɵfac = function DsContextualNavigationSubmenu_Factory(t) { return new (t || DsContextualNavigationSubmenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsContextualNavigationSubmenu.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsContextualNavigationSubmenu, selectors: [["ds-contextual-navigation-submenu"]], inputs: { boundaryLeft: "boundaryLeft", boundaryPadding: "boundaryPadding", boundaryRight: "boundaryRight", displayTitle: "displayTitle", exploreMenu: "exploreMenu", headerMargin: "headerMargin", items: "items", name: "name", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsContextualNavigationSubmenu_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsContextualNavigationSubmenu = __decorate([
        ProxyCmp({
            inputs: ['boundaryLeft', 'boundaryPadding', 'boundaryRight', 'displayTitle', 'exploreMenu', 'headerMargin', 'items', 'name', 'url']
        })
    ], DsContextualNavigationSubmenu);
    return DsContextualNavigationSubmenu;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsContextualNavigationSubmenu, [{
        type: Component,
        args: [{
                selector: 'ds-contextual-navigation-submenu',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['boundaryLeft', 'boundaryPadding', 'boundaryRight', 'displayTitle', 'exploreMenu', 'headerMargin', 'items', 'name', 'url'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsContextualNavigationSubmenu, { className: "DsContextualNavigationSubmenu", filePath: "directives/proxies.ts", lineNumber: 305 }); })();
var DsCustomScrollbar = /** @class */ (function () {
    function DsCustomScrollbar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsCustomScrollbar.ɵfac = function DsCustomScrollbar_Factory(t) { return new (t || DsCustomScrollbar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsCustomScrollbar.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsCustomScrollbar, selectors: [["ds-custom-scrollbar"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsCustomScrollbar_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsCustomScrollbar = __decorate([
        ProxyCmp({})
    ], DsCustomScrollbar);
    return DsCustomScrollbar;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsCustomScrollbar, [{
        type: Component,
        args: [{
                selector: 'ds-custom-scrollbar',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsCustomScrollbar, { className: "DsCustomScrollbar", filePath: "directives/proxies.ts", lineNumber: 326 }); })();
var DsDropdownBreadcrumbItem = /** @class */ (function () {
    function DsDropdownBreadcrumbItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsDropdownBreadcrumbItem.ɵfac = function DsDropdownBreadcrumbItem_Factory(t) { return new (t || DsDropdownBreadcrumbItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsDropdownBreadcrumbItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsDropdownBreadcrumbItem, selectors: [["ds-dropdown-breadcrumb-item"]], inputs: { dropdownItem: "dropdownItem", dropdownType: "dropdownType", isFirstChild: "isFirstChild", isLastChild: "isLastChild", itemNumber: "itemNumber" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsDropdownBreadcrumbItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsDropdownBreadcrumbItem = __decorate([
        ProxyCmp({
            inputs: ['dropdownItem', 'dropdownType', 'isFirstChild', 'isLastChild', 'itemNumber']
        })
    ], DsDropdownBreadcrumbItem);
    return DsDropdownBreadcrumbItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsDropdownBreadcrumbItem, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown-breadcrumb-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownItem', 'dropdownType', 'isFirstChild', 'isLastChild', 'itemNumber'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsDropdownBreadcrumbItem, { className: "DsDropdownBreadcrumbItem", filePath: "directives/proxies.ts", lineNumber: 348 }); })();
var DsDropdownBreadcrumbs = /** @class */ (function () {
    function DsDropdownBreadcrumbs(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsDropdownBreadcrumbs.ɵfac = function DsDropdownBreadcrumbs_Factory(t) { return new (t || DsDropdownBreadcrumbs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsDropdownBreadcrumbs.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsDropdownBreadcrumbs, selectors: [["ds-dropdown-breadcrumbs"]], inputs: { dropdownItems: "dropdownItems", dropdownType: "dropdownType" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsDropdownBreadcrumbs_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsDropdownBreadcrumbs = __decorate([
        ProxyCmp({
            inputs: ['dropdownItems', 'dropdownType']
        })
    ], DsDropdownBreadcrumbs);
    return DsDropdownBreadcrumbs;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsDropdownBreadcrumbs, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown-breadcrumbs',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownItems', 'dropdownType'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsDropdownBreadcrumbs, { className: "DsDropdownBreadcrumbs", filePath: "directives/proxies.ts", lineNumber: 370 }); })();
var DsDropdownBreadcrumbsList = /** @class */ (function () {
    function DsDropdownBreadcrumbsList(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsDropdownBreadcrumbsList.ɵfac = function DsDropdownBreadcrumbsList_Factory(t) { return new (t || DsDropdownBreadcrumbsList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsDropdownBreadcrumbsList.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsDropdownBreadcrumbsList, selectors: [["ds-dropdown-breadcrumbs-list"]], inputs: { dropdownItems: "dropdownItems", dropdownType: "dropdownType" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsDropdownBreadcrumbsList_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsDropdownBreadcrumbsList = __decorate([
        ProxyCmp({
            inputs: ['dropdownItems', 'dropdownType']
        })
    ], DsDropdownBreadcrumbsList);
    return DsDropdownBreadcrumbsList;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsDropdownBreadcrumbsList, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown-breadcrumbs-list',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownItems', 'dropdownType'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsDropdownBreadcrumbsList, { className: "DsDropdownBreadcrumbsList", filePath: "directives/proxies.ts", lineNumber: 392 }); })();
var DsDropdownBtnItem = /** @class */ (function () {
    function DsDropdownBtnItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsDropdownBtnItem.ɵfac = function DsDropdownBtnItem_Factory(t) { return new (t || DsDropdownBtnItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsDropdownBtnItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsDropdownBtnItem, selectors: [["ds-dropdown-btn-item"]], inputs: { dropdownItem: "dropdownItem", inDropdown: "inDropdown" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsDropdownBtnItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsDropdownBtnItem = __decorate([
        ProxyCmp({
            inputs: ['dropdownItem', 'inDropdown']
        })
    ], DsDropdownBtnItem);
    return DsDropdownBtnItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsDropdownBtnItem, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown-btn-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownItem', 'inDropdown'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsDropdownBtnItem, { className: "DsDropdownBtnItem", filePath: "directives/proxies.ts", lineNumber: 414 }); })();
var DsDropdownBtns = /** @class */ (function () {
    function DsDropdownBtns(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsDropdownBtns.ɵfac = function DsDropdownBtns_Factory(t) { return new (t || DsDropdownBtns)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsDropdownBtns.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsDropdownBtns, selectors: [["ds-dropdown-btns"]], inputs: { dropdownBtn: "dropdownBtn", hasDDItems: "hasDDItems", inDropdown: "inDropdown", isFirstChild: "isFirstChild", isLastChild: "isLastChild", noRegularBtns: "noRegularBtns" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsDropdownBtns_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsDropdownBtns = __decorate([
        ProxyCmp({
            inputs: ['dropdownBtn', 'hasDDItems', 'inDropdown', 'isFirstChild', 'isLastChild', 'noRegularBtns']
        })
    ], DsDropdownBtns);
    return DsDropdownBtns;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsDropdownBtns, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown-btns',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownBtn', 'hasDDItems', 'inDropdown', 'isFirstChild', 'isLastChild', 'noRegularBtns'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsDropdownBtns, { className: "DsDropdownBtns", filePath: "directives/proxies.ts", lineNumber: 436 }); })();
var DsDropdownNavItem = /** @class */ (function () {
    function DsDropdownNavItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsDropdownNavItem.ɵfac = function DsDropdownNavItem_Factory(t) { return new (t || DsDropdownNavItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsDropdownNavItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsDropdownNavItem, selectors: [["ds-dropdown-nav-item"]], inputs: { dropdownItem: "dropdownItem", dropdownType: "dropdownType", isFirstChild: "isFirstChild", isLastChild: "isLastChild", isScrollbar: "isScrollbar", itemNumber: "itemNumber" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsDropdownNavItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsDropdownNavItem = __decorate([
        ProxyCmp({
            inputs: ['dropdownItem', 'dropdownType', 'isFirstChild', 'isLastChild', 'isScrollbar', 'itemNumber']
        })
    ], DsDropdownNavItem);
    return DsDropdownNavItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsDropdownNavItem, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown-nav-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownItem', 'dropdownType', 'isFirstChild', 'isLastChild', 'isScrollbar', 'itemNumber'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsDropdownNavItem, { className: "DsDropdownNavItem", filePath: "directives/proxies.ts", lineNumber: 458 }); })();
var DsDropdownNavItems = /** @class */ (function () {
    function DsDropdownNavItems(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsDropdownNavItems.ɵfac = function DsDropdownNavItems_Factory(t) { return new (t || DsDropdownNavItems)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsDropdownNavItems.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsDropdownNavItems, selectors: [["ds-dropdown-nav-items"]], inputs: { dropdownBtnTitle: "dropdownBtnTitle", dropdownBtns: "dropdownBtns", dropdownItems: "dropdownItems", dropdownType: "dropdownType", isSticky: "isSticky", navTabsComponentClass: "navTabsComponentClass" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsDropdownNavItems_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsDropdownNavItems = __decorate([
        ProxyCmp({
            inputs: ['dropdownBtnTitle', 'dropdownBtns', 'dropdownItems', 'dropdownType', 'isSticky', 'navTabsComponentClass']
        })
    ], DsDropdownNavItems);
    return DsDropdownNavItems;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsDropdownNavItems, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown-nav-items',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dropdownBtnTitle', 'dropdownBtns', 'dropdownItems', 'dropdownType', 'isSticky', 'navTabsComponentClass'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsDropdownNavItems, { className: "DsDropdownNavItems", filePath: "directives/proxies.ts", lineNumber: 480 }); })();
var DsFlexCol = /** @class */ (function () {
    function DsFlexCol(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsFlexCol.ɵfac = function DsFlexCol_Factory(t) { return new (t || DsFlexCol)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsFlexCol.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsFlexCol, selectors: [["ds-flex-col"]], inputs: { lg: "lg", md: "md", offset: "offset", size: "size", sm: "sm", xl: "xl", xs: "xs" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsFlexCol_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsFlexCol = __decorate([
        ProxyCmp({
            inputs: ['lg', 'md', 'offset', 'size', 'sm', 'xl', 'xs']
        })
    ], DsFlexCol);
    return DsFlexCol;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsFlexCol, [{
        type: Component,
        args: [{
                selector: 'ds-flex-col',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['lg', 'md', 'offset', 'size', 'sm', 'xl', 'xs'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsFlexCol, { className: "DsFlexCol", filePath: "directives/proxies.ts", lineNumber: 502 }); })();
var DsFlexGrid = /** @class */ (function () {
    function DsFlexGrid(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsFlexGrid.ɵfac = function DsFlexGrid_Factory(t) { return new (t || DsFlexGrid)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsFlexGrid.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsFlexGrid, selectors: [["ds-flex-grid"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsFlexGrid_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsFlexGrid = __decorate([
        ProxyCmp({})
    ], DsFlexGrid);
    return DsFlexGrid;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsFlexGrid, [{
        type: Component,
        args: [{
                selector: 'ds-flex-grid',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsFlexGrid, { className: "DsFlexGrid", filePath: "directives/proxies.ts", lineNumber: 523 }); })();
var DsFlexRow = /** @class */ (function () {
    function DsFlexRow(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsFlexRow.ɵfac = function DsFlexRow_Factory(t) { return new (t || DsFlexRow)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsFlexRow.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsFlexRow, selectors: [["ds-flex-row"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsFlexRow_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsFlexRow = __decorate([
        ProxyCmp({})
    ], DsFlexRow);
    return DsFlexRow;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsFlexRow, [{
        type: Component,
        args: [{
                selector: 'ds-flex-row',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsFlexRow, { className: "DsFlexRow", filePath: "directives/proxies.ts", lineNumber: 544 }); })();
var DsFooter = /** @class */ (function () {
    function DsFooter(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['footerDidLoad']);
    }
    DsFooter.ɵfac = function DsFooter_Factory(t) { return new (t || DsFooter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsFooter.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsFooter, selectors: [["ds-footer"]], inputs: { isLightTheme: "isLightTheme", isShowCookiePreferences: "isShowCookiePreferences", navigationItems: "navigationItems", socialLinks: "socialLinks", socialLinksTitle: "socialLinksTitle" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsFooter_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsFooter = __decorate([
        ProxyCmp({
            inputs: ['isLightTheme', 'isShowCookiePreferences', 'navigationItems', 'socialLinks', 'socialLinksTitle']
        })
    ], DsFooter);
    return DsFooter;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsFooter, [{
        type: Component,
        args: [{
                selector: 'ds-footer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['isLightTheme', 'isShowCookiePreferences', 'navigationItems', 'socialLinks', 'socialLinksTitle'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsFooter, { className: "DsFooter", filePath: "directives/proxies.ts", lineNumber: 566 }); })();
var DsFooterNavigation = /** @class */ (function () {
    function DsFooterNavigation(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['openCookiePreferences']);
    }
    DsFooterNavigation.ɵfac = function DsFooterNavigation_Factory(t) { return new (t || DsFooterNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsFooterNavigation.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsFooterNavigation, selectors: [["ds-footer-navigation"]], inputs: { isShowCookieInFooter: "isShowCookieInFooter", navigationItems: "navigationItems" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsFooterNavigation_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsFooterNavigation = __decorate([
        ProxyCmp({
            inputs: ['isShowCookieInFooter', 'navigationItems']
        })
    ], DsFooterNavigation);
    return DsFooterNavigation;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsFooterNavigation, [{
        type: Component,
        args: [{
                selector: 'ds-footer-navigation',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['isShowCookieInFooter', 'navigationItems'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsFooterNavigation, { className: "DsFooterNavigation", filePath: "directives/proxies.ts", lineNumber: 592 }); })();
var DsHeader = /** @class */ (function () {
    function DsHeader(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsHeader.ɵfac = function DsHeader_Factory(t) { return new (t || DsHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeader, selectors: [["ds-header"]], inputs: { avatarSourceUrl: "avatarSourceUrl", contactUsConfig: "contactUsConfig", identifier: "identifier", landingZoneIdentifier: "landingZoneIdentifier", landingZoneNavVersion: "landingZoneNavVersion", lastVisitedCountry: "lastVisitedCountry", locale: "locale", loggedInUser: "loggedInUser", mode: "mode", notificationBellConfig: "notificationBellConfig", notifications: "notifications", s3Bucket: "s3Bucket", touchpointConfigVersion: "touchpointConfigVersion", touchpointIdentifier: "touchpointIdentifier", translations: "translations" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeader_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeader = __decorate([
        ProxyCmp({
            inputs: ['avatarSourceUrl', 'contactUsConfig', 'identifier', 'landingZoneIdentifier', 'landingZoneNavVersion', 'lastVisitedCountry', 'locale', 'loggedInUser', 'mode', 'notificationBellConfig', 'notifications', 's3Bucket', 'touchpointConfigVersion', 'touchpointIdentifier', 'translations']
        })
    ], DsHeader);
    return DsHeader;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeader, [{
        type: Component,
        args: [{
                selector: 'ds-header',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['avatarSourceUrl', 'contactUsConfig', 'identifier', 'landingZoneIdentifier', 'landingZoneNavVersion', 'lastVisitedCountry', 'locale', 'loggedInUser', 'mode', 'notificationBellConfig', 'notifications', 's3Bucket', 'touchpointConfigVersion', 'touchpointIdentifier', 'translations'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeader, { className: "DsHeader", filePath: "directives/proxies.ts", lineNumber: 618 }); })();
var DsHeaderMobileContactUs = /** @class */ (function () {
    function DsHeaderMobileContactUs(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['mobileMenuClicked', 'cxsdsHeaderOpenChat', 'cxsdsHeaderOpenContactUs']);
    }
    DsHeaderMobileContactUs.ɵfac = function DsHeaderMobileContactUs_Factory(t) { return new (t || DsHeaderMobileContactUs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderMobileContactUs.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderMobileContactUs, selectors: [["ds-header-mobile-contact-us"]], inputs: { config: "config", open: "open" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderMobileContactUs_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderMobileContactUs = __decorate([
        ProxyCmp({
            inputs: ['config', 'open']
        })
    ], DsHeaderMobileContactUs);
    return DsHeaderMobileContactUs;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderMobileContactUs, [{
        type: Component,
        args: [{
                selector: 'ds-header-mobile-contact-us',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['config', 'open'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderMobileContactUs, { className: "DsHeaderMobileContactUs", filePath: "directives/proxies.ts", lineNumber: 640 }); })();
var DsHeaderMobileNavigation = /** @class */ (function () {
    function DsHeaderMobileNavigation(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['mobileMenuClicked']);
    }
    DsHeaderMobileNavigation.ɵfac = function DsHeaderMobileNavigation_Factory(t) { return new (t || DsHeaderMobileNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderMobileNavigation.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderMobileNavigation, selectors: [["ds-header-mobile-navigation"]], inputs: { exploreSapLink: "exploreSapLink", hideExploreSapLink: "hideExploreSapLink", navigationContext: "navigationContext", open: "open" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderMobileNavigation_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderMobileNavigation = __decorate([
        ProxyCmp({
            inputs: ['exploreSapLink', 'hideExploreSapLink', 'navigationContext', 'open']
        })
    ], DsHeaderMobileNavigation);
    return DsHeaderMobileNavigation;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderMobileNavigation, [{
        type: Component,
        args: [{
                selector: 'ds-header-mobile-navigation',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['exploreSapLink', 'hideExploreSapLink', 'navigationContext', 'open'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderMobileNavigation, { className: "DsHeaderMobileNavigation", filePath: "directives/proxies.ts", lineNumber: 670 }); })();
var DsHeaderMobileNotificationBell = /** @class */ (function () {
    function DsHeaderMobileNotificationBell(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsHeaderMobileNotificationBell.ɵfac = function DsHeaderMobileNotificationBell_Factory(t) { return new (t || DsHeaderMobileNotificationBell)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderMobileNotificationBell.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderMobileNotificationBell, selectors: [["ds-header-mobile-notification-bell"]], inputs: { hasUnreadNotifications: "hasUnreadNotifications", openInNewTab: "openInNewTab", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderMobileNotificationBell_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderMobileNotificationBell = __decorate([
        ProxyCmp({
            inputs: ['hasUnreadNotifications', 'openInNewTab', 'url']
        })
    ], DsHeaderMobileNotificationBell);
    return DsHeaderMobileNotificationBell;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderMobileNotificationBell, [{
        type: Component,
        args: [{
                selector: 'ds-header-mobile-notification-bell',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['hasUnreadNotifications', 'openInNewTab', 'url'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderMobileNotificationBell, { className: "DsHeaderMobileNotificationBell", filePath: "directives/proxies.ts", lineNumber: 696 }); })();
var DsHeaderMobileReturnButton = /** @class */ (function () {
    function DsHeaderMobileReturnButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsHeaderMobileReturnButton.ɵfac = function DsHeaderMobileReturnButton_Factory(t) { return new (t || DsHeaderMobileReturnButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderMobileReturnButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderMobileReturnButton, selectors: [["ds-header-mobile-return-button"]], inputs: { buttonTitle: "buttonTitle", triggerOnReturn: "triggerOnReturn" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderMobileReturnButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderMobileReturnButton = __decorate([
        ProxyCmp({
            inputs: ['buttonTitle', 'triggerOnReturn']
        })
    ], DsHeaderMobileReturnButton);
    return DsHeaderMobileReturnButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderMobileReturnButton, [{
        type: Component,
        args: [{
                selector: 'ds-header-mobile-return-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['buttonTitle', 'triggerOnReturn'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderMobileReturnButton, { className: "DsHeaderMobileReturnButton", filePath: "directives/proxies.ts", lineNumber: 718 }); })();
var DsHeaderMobileShoppingCart = /** @class */ (function () {
    function DsHeaderMobileShoppingCart(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsHeaderMobileShoppingCart.ɵfac = function DsHeaderMobileShoppingCart_Factory(t) { return new (t || DsHeaderMobileShoppingCart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderMobileShoppingCart.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderMobileShoppingCart, selectors: [["ds-header-mobile-shopping-cart"]], inputs: { hasUnreadNotifications: "hasUnreadNotifications", internalLink: "internalLink", isFull: "isFull", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderMobileShoppingCart_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderMobileShoppingCart = __decorate([
        ProxyCmp({
            inputs: ['hasUnreadNotifications', 'internalLink', 'isFull', 'url']
        })
    ], DsHeaderMobileShoppingCart);
    return DsHeaderMobileShoppingCart;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderMobileShoppingCart, [{
        type: Component,
        args: [{
                selector: 'ds-header-mobile-shopping-cart',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['hasUnreadNotifications', 'internalLink', 'isFull', 'url'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderMobileShoppingCart, { className: "DsHeaderMobileShoppingCart", filePath: "directives/proxies.ts", lineNumber: 740 }); })();
var DsHeaderNotificationBell = /** @class */ (function () {
    function DsHeaderNotificationBell(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsHeaderNotificationBell.ɵfac = function DsHeaderNotificationBell_Factory(t) { return new (t || DsHeaderNotificationBell)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderNotificationBell.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderNotificationBell, selectors: [["ds-header-notification-bell"]], inputs: { hasUnreadNotifications: "hasUnreadNotifications", openInNewTab: "openInNewTab", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderNotificationBell_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderNotificationBell = __decorate([
        ProxyCmp({
            inputs: ['hasUnreadNotifications', 'openInNewTab', 'url']
        })
    ], DsHeaderNotificationBell);
    return DsHeaderNotificationBell;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderNotificationBell, [{
        type: Component,
        args: [{
                selector: 'ds-header-notification-bell',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['hasUnreadNotifications', 'openInNewTab', 'url'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderNotificationBell, { className: "DsHeaderNotificationBell", filePath: "directives/proxies.ts", lineNumber: 762 }); })();
var DsHeaderShoppingCart = /** @class */ (function () {
    function DsHeaderShoppingCart(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsHeaderShoppingCart.ɵfac = function DsHeaderShoppingCart_Factory(t) { return new (t || DsHeaderShoppingCart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderShoppingCart.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderShoppingCart, selectors: [["ds-header-shopping-cart"]], inputs: { hasUnreadNotifications: "hasUnreadNotifications", internalLink: "internalLink", isFull: "isFull", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderShoppingCart_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderShoppingCart = __decorate([
        ProxyCmp({
            inputs: ['hasUnreadNotifications', 'internalLink', 'isFull', 'url']
        })
    ], DsHeaderShoppingCart);
    return DsHeaderShoppingCart;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderShoppingCart, [{
        type: Component,
        args: [{
                selector: 'ds-header-shopping-cart',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['hasUnreadNotifications', 'internalLink', 'isFull', 'url'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderShoppingCart, { className: "DsHeaderShoppingCart", filePath: "directives/proxies.ts", lineNumber: 784 }); })();
var DsHeaderSubmenuRow = /** @class */ (function () {
    function DsHeaderSubmenuRow(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['blurSubmenuLink']);
    }
    DsHeaderSubmenuRow.ɵfac = function DsHeaderSubmenuRow_Factory(t) { return new (t || DsHeaderSubmenuRow)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsHeaderSubmenuRow.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsHeaderSubmenuRow, selectors: [["ds-header-submenu-row"]], inputs: { isAdjustable: "isAdjustable", isExploreMenu: "isExploreMenu", subMenuRow: "subMenuRow", subMenuTitle: "subMenuTitle" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsHeaderSubmenuRow_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsHeaderSubmenuRow = __decorate([
        ProxyCmp({
            inputs: ['isAdjustable', 'isExploreMenu', 'subMenuRow', 'subMenuTitle']
        })
    ], DsHeaderSubmenuRow);
    return DsHeaderSubmenuRow;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsHeaderSubmenuRow, [{
        type: Component,
        args: [{
                selector: 'ds-header-submenu-row',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['isAdjustable', 'isExploreMenu', 'subMenuRow', 'subMenuTitle'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsHeaderSubmenuRow, { className: "DsHeaderSubmenuRow", filePath: "directives/proxies.ts", lineNumber: 806 }); })();
var DsIcon = /** @class */ (function () {
    function DsIcon(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsIcon.ɵfac = function DsIcon_Factory(t) { return new (t || DsIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsIcon.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsIcon, selectors: [["ds-icon"]], inputs: { iconRole: "iconRole", name: "name", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsIcon_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsIcon = __decorate([
        ProxyCmp({
            inputs: ['iconRole', 'name', 'size']
        })
    ], DsIcon);
    return DsIcon;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsIcon, [{
        type: Component,
        args: [{
                selector: 'ds-icon',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['iconRole', 'name', 'size'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsIcon, { className: "DsIcon", filePath: "directives/proxies.ts", lineNumber: 832 }); })();
var DsIconOff = /** @class */ (function () {
    function DsIconOff(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsIconOff.ɵfac = function DsIconOff_Factory(t) { return new (t || DsIconOff)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsIconOff.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsIconOff, selectors: [["ds-icon-off"]], inputs: { iconRole: "iconRole", name: "name", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsIconOff_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsIconOff = __decorate([
        ProxyCmp({
            inputs: ['iconRole', 'name', 'size']
        })
    ], DsIconOff);
    return DsIconOff;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsIconOff, [{
        type: Component,
        args: [{
                selector: 'ds-icon-off',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['iconRole', 'name', 'size'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsIconOff, { className: "DsIconOff", filePath: "directives/proxies.ts", lineNumber: 854 }); })();
var DsLink = /** @class */ (function () {
    function DsLink(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsLink.ɵfac = function DsLink_Factory(t) { return new (t || DsLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsLink.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsLink, selectors: [["ds-link"]], inputs: { href: "href", label: "label", linkTitle: "linkTitle", target: "target", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsLink_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsLink = __decorate([
        ProxyCmp({
            inputs: ['href', 'label', 'linkTitle', 'target', 'type']
        })
    ], DsLink);
    return DsLink;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsLink, [{
        type: Component,
        args: [{
                selector: 'ds-link',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['href', 'label', 'linkTitle', 'target', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsLink, { className: "DsLink", filePath: "directives/proxies.ts", lineNumber: 876 }); })();
var DsNavTabsComponent = /** @class */ (function () {
    function DsNavTabsComponent(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsNavTabsComponent.ɵfac = function DsNavTabsComponent_Factory(t) { return new (t || DsNavTabsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsNavTabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsNavTabsComponent, selectors: [["ds-nav-tabs-component"]], inputs: { btnItems: "btnItems", dropdownBtnTitle: "dropdownBtnTitle", dropdownBtns: "dropdownBtns", hiddenNavItems: "hiddenNavItems", isSticky: "isSticky", navTabItems: "navTabItems", navTabsComponentClass: "navTabsComponentClass" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsNavTabsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsNavTabsComponent = __decorate([
        ProxyCmp({
            inputs: ['btnItems', 'dropdownBtnTitle', 'dropdownBtns', 'hiddenNavItems', 'isSticky', 'navTabItems', 'navTabsComponentClass']
        })
    ], DsNavTabsComponent);
    return DsNavTabsComponent;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsNavTabsComponent, [{
        type: Component,
        args: [{
                selector: 'ds-nav-tabs-component',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['btnItems', 'dropdownBtnTitle', 'dropdownBtns', 'hiddenNavItems', 'isSticky', 'navTabItems', 'navTabsComponentClass'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsNavTabsComponent, { className: "DsNavTabsComponent", filePath: "directives/proxies.ts", lineNumber: 898 }); })();
var DsNavigationTabItem = /** @class */ (function () {
    function DsNavigationTabItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsNavigationTabItem.ɵfac = function DsNavigationTabItem_Factory(t) { return new (t || DsNavigationTabItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsNavigationTabItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsNavigationTabItem, selectors: [["ds-navigation-tab-item"]], inputs: { navTabsComponentClass: "navTabsComponentClass", navigationTabItem: "navigationTabItem" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsNavigationTabItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsNavigationTabItem = __decorate([
        ProxyCmp({
            inputs: ['navTabsComponentClass', 'navigationTabItem']
        })
    ], DsNavigationTabItem);
    return DsNavigationTabItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsNavigationTabItem, [{
        type: Component,
        args: [{
                selector: 'ds-navigation-tab-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['navTabsComponentClass', 'navigationTabItem'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsNavigationTabItem, { className: "DsNavigationTabItem", filePath: "directives/proxies.ts", lineNumber: 920 }); })();
var DsNotificationDot = /** @class */ (function () {
    function DsNotificationDot(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsNotificationDot.ɵfac = function DsNotificationDot_Factory(t) { return new (t || DsNotificationDot)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsNotificationDot.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsNotificationDot, selectors: [["ds-notification-dot"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsNotificationDot_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsNotificationDot = __decorate([
        ProxyCmp({})
    ], DsNotificationDot);
    return DsNotificationDot;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsNotificationDot, [{
        type: Component,
        args: [{
                selector: 'ds-notification-dot',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsNotificationDot, { className: "DsNotificationDot", filePath: "directives/proxies.ts", lineNumber: 941 }); })();
var DsSearchInput = /** @class */ (function () {
    function DsSearchInput(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['searchInputClosed', 'searchInputCleared', 'searchQueryChanged', 'searchQuerySubmitted']);
    }
    DsSearchInput.ɵfac = function DsSearchInput_Factory(t) { return new (t || DsSearchInput)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsSearchInput.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsSearchInput, selectors: [["ds-search-input"]], inputs: { allowEmptySearchSubmit: "allowEmptySearchSubmit", autoFocus: "autoFocus", hideSubmitButton: "hideSubmitButton", inputName: "inputName", placeholder: "placeholder", queryParameters: "queryParameters", type: "type", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsSearchInput_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsSearchInput = __decorate([
        ProxyCmp({
            inputs: ['allowEmptySearchSubmit', 'autoFocus', 'hideSubmitButton', 'inputName', 'placeholder', 'queryParameters', 'type', 'url'],
            methods: ['setValue']
        })
    ], DsSearchInput);
    return DsSearchInput;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsSearchInput, [{
        type: Component,
        args: [{
                selector: 'ds-search-input',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['allowEmptySearchSubmit', 'autoFocus', 'hideSubmitButton', 'inputName', 'placeholder', 'queryParameters', 'type', 'url'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsSearchInput, { className: "DsSearchInput", filePath: "directives/proxies.ts", lineNumber: 964 }); })();
var DsSecondaryNavigation = /** @class */ (function () {
    function DsSecondaryNavigation(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['sapSecondaryNavComponentWillLoad', 'cxsdsSecondaryNavComponentReady']);
    }
    DsSecondaryNavigation.ɵfac = function DsSecondaryNavigation_Factory(t) { return new (t || DsSecondaryNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsSecondaryNavigation.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsSecondaryNavigation, selectors: [["ds-secondary-navigation"]], inputs: { breadcrumbJson: "breadcrumbJson", breadcrumbsMinCount: "breadcrumbsMinCount", btnItemsJson: "btnItemsJson", dropdownBtnTitle: "dropdownBtnTitle", isSsr: "isSsr", isSticky: "isSticky", navConfig: "navConfig", navTabJson: "navTabJson", pageHeadingJson: "pageHeadingJson" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsSecondaryNavigation_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsSecondaryNavigation = __decorate([
        ProxyCmp({
            inputs: ['breadcrumbJson', 'breadcrumbsMinCount', 'btnItemsJson', 'dropdownBtnTitle', 'isSsr', 'isSticky', 'navConfig', 'navTabJson', 'pageHeadingJson']
        })
    ], DsSecondaryNavigation);
    return DsSecondaryNavigation;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsSecondaryNavigation, [{
        type: Component,
        args: [{
                selector: 'ds-secondary-navigation',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['breadcrumbJson', 'breadcrumbsMinCount', 'btnItemsJson', 'dropdownBtnTitle', 'isSsr', 'isSticky', 'navConfig', 'navTabJson', 'pageHeadingJson'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsSecondaryNavigation, { className: "DsSecondaryNavigation", filePath: "directives/proxies.ts", lineNumber: 996 }); })();
var DsSocialLink = /** @class */ (function () {
    function DsSocialLink(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsSocialLink.ɵfac = function DsSocialLink_Factory(t) { return new (t || DsSocialLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsSocialLink.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsSocialLink, selectors: [["ds-social-link"]], inputs: { iconName: "iconName", isShareLink: "isShareLink", name: "name", rel: "rel", target: "target", tooltip: "tooltip", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsSocialLink_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsSocialLink = __decorate([
        ProxyCmp({
            inputs: ['iconName', 'isShareLink', 'name', 'rel', 'target', 'tooltip', 'url']
        })
    ], DsSocialLink);
    return DsSocialLink;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsSocialLink, [{
        type: Component,
        args: [{
                selector: 'ds-social-link',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['iconName', 'isShareLink', 'name', 'rel', 'target', 'tooltip', 'url'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsSocialLink, { className: "DsSocialLink", filePath: "directives/proxies.ts", lineNumber: 1024 }); })();
var DsSocialLinks = /** @class */ (function () {
    function DsSocialLinks(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    DsSocialLinks.ɵfac = function DsSocialLinks_Factory(t) { return new (t || DsSocialLinks)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    DsSocialLinks.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DsSocialLinks, selectors: [["ds-social-links"]], inputs: { headline: "headline", socialLinks: "socialLinks" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function DsSocialLinks_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    DsSocialLinks = __decorate([
        ProxyCmp({
            inputs: ['headline', 'socialLinks']
        })
    ], DsSocialLinks);
    return DsSocialLinks;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DsSocialLinks, [{
        type: Component,
        args: [{
                selector: 'ds-social-links',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['headline', 'socialLinks'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DsSocialLinks, { className: "DsSocialLinks", filePath: "directives/proxies.ts", lineNumber: 1046 }); })();

// tslint:disable-next-line
if ('undefined' !== typeof window) {
    defineCustomElements(window);
}
var DECLARATIONS = [
    // proxies
    DsButton,
    DsIcon,
    DsContextualNavigation
];
var ComponentLibraryModule = /** @class */ (function () {
    function ComponentLibraryModule() {
    }
    ComponentLibraryModule.ɵfac = function ComponentLibraryModule_Factory(t) { return new (t || ComponentLibraryModule)(); };
    ComponentLibraryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ComponentLibraryModule });
    ComponentLibraryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
    return ComponentLibraryModule;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: DECLARATIONS,
                exports: DECLARATIONS,
                imports: [],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ComponentLibraryModule, { declarations: [
        // proxies
        DsButton,
        DsIcon,
        DsContextualNavigation], exports: [
        // proxies
        DsButton,
        DsIcon,
        DsContextualNavigation] }); })();

export { ComponentLibraryModule, DsActionMenu, DsBadge, DsBreadcrumbElement, DsBtnContainer, DsButton, DsButtonComponent, DsContextualNavigation, DsContextualNavigationCountrySelector, DsContextualNavigationMobileMasthead, DsContextualNavigationMobileProfile, DsContextualNavigationProfile, DsContextualNavigationSubmenu, DsCustomScrollbar, DsDropdownBreadcrumbItem, DsDropdownBreadcrumbs, DsDropdownBreadcrumbsList, DsDropdownBtnItem, DsDropdownBtns, DsDropdownNavItem, DsDropdownNavItems, DsFlexCol, DsFlexGrid, DsFlexRow, DsFooter, DsFooterNavigation, DsHeader, DsHeaderMobileContactUs, DsHeaderMobileNavigation, DsHeaderMobileNotificationBell, DsHeaderMobileReturnButton, DsHeaderMobileShoppingCart, DsHeaderNotificationBell, DsHeaderShoppingCart, DsHeaderSubmenuRow, DsIcon, DsIconOff, DsLink, DsNavTabsComponent, DsNavigationTabItem, DsNotificationDot, DsSearchInput, DsSecondaryNavigation, DsSocialLink, DsSocialLinks };
